import { render } from "./link.vue?vue&type=template&id=e8d3efd6&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"

import "./link.vue?vue&type=style&index=0&id=e8d3efd6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d3efd6"]])

export default __exports__